import React from "react";
import { Select } from "antd";
import { oneSignalNotificationTypes } from "constants/constants";
const NotificationTypeFilter = ({
    value,
    onChange,
    allowClear = true,
    placeholder = "Bildirim Tipi Seçin",
    style = {width: 250}
}) => {
    return (
        <Select
            style={style}   
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            allowClear
            showSearch
            filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {oneSignalNotificationTypes.map(notificationType => (
                <Select.Option key={notificationType.value} value={notificationType.value}>
                    {notificationType.label}
                </Select.Option>
            ))}
        </Select>
    );
};

export default NotificationTypeFilter;